import React from "react";
import { arrayIsNotEmpty, isPresent } from "src/utils/checks";
import SectionSuites, {
  CruiseSectionSuitesProps
} from "src/page-components/cruise/suites/SectionSuites";
import ShipDiningAreas from "src/page-components/cruise/ship/ShipDiningAreas";
import ShipDiningAreasRows from "src/page-components/cruise/ship/ShipDiningAreasRows";
import ShipPublicAreas from "src/page-components/cruise/ship/ShipPublicAreas";
import ShipIntro from "src/page-components/cruise/ship/ShipIntro";
import { BlockContentValue } from "@silversea-ssc/ui-components-react";
import TextBox from "components/TextBox/TextBox";

type CruiseSectionShipProps = Omit<CruiseSectionSuitesProps, "title"> & {
  shipSectionId: string;
  suitesSectionId: string;
  suiteSectionTitle: string | undefined;
  suiteSectionContent: BlockContentValue | undefined;
};

const ShipSection: React.FC<CruiseSectionShipProps> = ({
  ship,
  shipVersion,
  cruisePrice,
  cruiseCode,
  activePromos,
  ecommerceStatus,
  shipSectionId,
  suitesSectionId,
  suiteSectionTitle,
  suiteSectionContent,
  raqPagePath
}) => {
  if (!shipVersion) throw `No current version for ship ${ship.name}`;

  const diningAreas = shipVersion.diningAreas?.filter(isPresent);
  const facilities = shipVersion.facilities?.filter(isPresent);

  return (
    <React.Fragment>
      <div id={shipSectionId}>
        <ShipIntro
          ship={ship}
          shipVersion={shipVersion}
          ecommerceStatus={ecommerceStatus}
        />
      </div>
      <div id={suitesSectionId}>
        <SectionSuites
          ship={ship}
          shipVersion={shipVersion}
          cruiseCode={cruiseCode}
          cruisePrice={cruisePrice}
          ecommerceStatus={ecommerceStatus}
          activePromos={activePromos}
          backgroundColor="productTypeColor02"
          title={suiteSectionTitle}
          raqPagePath={raqPagePath}
        >
          <TextBox content={suiteSectionContent} fontSize="inherit" />
        </SectionSuites>

        {arrayIsNotEmpty(diningAreas) && (
          <ShipDiningAreas
            diningAreas={diningAreas}
            shipName={ship.name!}
            backgroundColor="neutral05"
          >
            <ShipDiningAreasRows diningAreas={diningAreas} />
          </ShipDiningAreas>
        )}
      </div>
      {arrayIsNotEmpty(facilities) && (
        <ShipPublicAreas facilities={facilities} />
      )}
    </React.Fragment>
  );
};

export default React.memo(ShipSection);
